import React, { useState } from "react";
import { useParams } from "react-router-dom";
import stringify from "json-stringify-pretty-compact";

import dayjs from "dayjs-local";
import { useLiveData } from "hooks";
import { Page } from "modules/layout/Page";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "components/Table";
import { PauseButton } from "components/PauseButton";
import { FirebaseShard } from "firebaseWrapper";

import { DeviceStatus } from "../components/DeviceStatus";

interface MessageData {
  timestamp_utc: string;
}

export const MessageDetailsPage = () => {
  const {
    siteId,
    unitId,
    deviceId,
    messageCategory,
    messageType,
  } = useParams();
  const [latestData, setLatestData] = useState<MessageData[]>([]);
  const [isPaused, setIsPaused] = useState<boolean>(false);

  useLiveData(
    {
      isPaused: isPaused,
      maxDataPoints: 20,
      firebaseShard: FirebaseShard.Tracing,
      firebaseRef: `devices/dataBySite/${siteId}/historyByDevice/${unitId}/${deviceId}/${messageCategory}/${messageType}`,
      orderByDescending: true,
      onInitialData: setLatestData,
      onIncrementalData: setLatestData,
    },
    [deviceId, messageCategory, messageType]
  );

  return (
    <Page
      titleSupplement={
        <DeviceStatus
          siteId={siteId}
          unitId={unitId}
          deviceId={deviceId}
          className="ml-2"
        />
      }
      titleButtons={
        <>
          <PauseButton
            isPaused={isPaused}
            onClick={() => setIsPaused((state) => !state)}
          />
        </>
      }
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell nowrap>Message Date</TableHeaderCell>
            <TableHeaderCell>Message</TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {latestData.map((message, index) => (
            <TableRow key={index}>
              <TableCell nowrap>
                {dayjs.utc(message.timestamp_utc).fromNow()}
              </TableCell>
              <TableCell className="">
                <div className="rounded-lg">
                  <div className="bg-gray-800 p-4 font-mono text-xs text-white whitespace-pre-wrap">
                    {stringify(message, {
                      maxLength: JSON.stringify(message).length - 1,
                    })}
                  </div>
                </div>
              </TableCell>
            </TableRow>
          ))}
          {latestData.length === 0 && (
            <TableRow>
              <TableCell nowrap>
                No {messageCategory}/{messageType} messages received from this
                device
              </TableCell>
              <TableCell />
              <TableCell />
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Page>
  );
};
